<template>
  <header id="xs-header" :class="isIndex">
    <img id="xs-logo" src="../assets/logo.png" />
    <nav id="xs-navs">
      <router-link :class="{selected: $route.name === 'index'}" tag="span" to="/">首页</router-link>
      <router-link :class="{selected: $route.name === 'product'}" tag="span" to="/product">产品</router-link>
      <router-link :class="{selected: $route.name === 'opportunity'}" tag="span" to="/opportunity">行业机会</router-link>
      <router-link :class="{selected: $route.name === 'solution'}" tag="span" to="/solution">解决方案</router-link>
      <router-link :class="{selected: $route.name === 'business'}" tag="span" to="/business">商务合作</router-link>
      <!--<router-link :class="{selected: $route.name === 'business'}" tag="span" to="/business">商务合作</router-link>-->
      <router-link :class="{selected: $route.name === 'technique'}" tag="span" to="/technique">技术优势</router-link>
      <router-link :class="{selected: $route.name === 'project'}" tag="span" to="/project">项目介绍</router-link>
    </nav>
  </header>
</template>

<script>

export default {
  name: 'xs-header',
  data () {
    return {
      isIndex: '',
      temp: 0
    }
  },
  watch: {
    '$route' (to) {
      console.log('ok')
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
      if (to.name !== 'index') {
        this.isIndex = 'isIndex'
      } else {
        this.isIndex = ''
      }
    }
  },
  mounted () {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    if (this.$route.name !== 'index') {
      this.isIndex = 'isIndex'
    } else {
      this.isIndex = ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
#xs-header  {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1;
}
#xs-logo {
  position: absolute;
  top: 21px;
  left: 50px;
  height: 28px;
}
#xs-navs {
  text-align: center;
  padding: 20px;
  min-width: 1280px;
  span {
    position: relative;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    padding: 0px;
    margin: 0 40px;
    display: inline-block;
    vertical-align: top;
    cursor: pointer;
  }
  span.selected {
    color: #3692fb!important;
    border-bottom: 2px solid #3692fb!important;
  }
}
.isIndex {
  background-color: #fff;
  border-bottom: 2px solid #f9f9f9;
}
</style>



// WEBPACK FOOTER //
// src/components/XSHeader.vue